import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

@Component({
  standalone: true,
  selector: 'tax-empty-list',
  templateUrl: 'empty-list.component.html',
  styleUrls: ['empty-list.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    NgIf,
  ],
})

export class EmptyListComponent {
  @Input() text?: string;
}
